export default __webpack_public_path__ + "static/media/Simulation.abaa5fba.jpg";